import { connect } from "react-redux";
import NotQuiteStickyHeader from "./NotQuiteStickyHeader";
import {
  getViewport,
  isSidePanelOpen,
  isCookieMessageOpen
} from "../../state/modules/layout";
import { getFeaturesLoaded } from "@template/state/modules/features";

function mapStateToProps(state) {
  return {
    viewportCategory: getViewport(state),
    isSidePanelOpen: isSidePanelOpen(state),
    cookieMessageOpen: isCookieMessageOpen(state),
    featuresLoaded: getFeaturesLoaded(state)
  };
}

export default connect(mapStateToProps)(NotQuiteStickyHeader);
